import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import "./footer.scss";

const FooterOfRent = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            IT_total,
            IT_paied,
            IT_discount,
            IT_joripara,
            dinartodolar,
            dolartodinar
          } = value;
          return (
            <>
              <html dir="rtl">
                <div className="row fk">
                  <div className="col-2"></div>
                  <div className="col-6">
                    {/* {R_WakilQard_isChecked == true &&
                      R_frosth == "فرۆشتنی وەکیل" ? (
                      <>
                        <table className="responstable">
                          <tr>
                            <th scope="row" style={{ fontSize: "25px" }}>
                              قەرزی کۆن
                            </th>
                            <td
                              className="text-danger1"
                              style={{
                                fontSize: "25px",
                                backgroundColor: "#80bfea"
                              }}
                            >
                              <NumberFormat
                                value={
                                  IT_joripara == "دۆلار"
                                    ? Number(R_rasidWakildinarNew)
                                    : Number(R_rasidWakildolarNew)
                                }
                                thousandSeparator={true}
                                displayType="text"
                                prefix={IT_joripara == "دۆلار" ? "IQD" : "$"}
                              />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row" style={{ fontSize: "25px" }}>
                              قەرزی کۆن
                            </th>
                            <td style={{ fontSize: "25px" }}>
                              <NumberFormat
                                value={
                                  IT_joripara == "دۆلار"
                                    ? Number(R_rasidWakildolar).toFixed(2)
                                    : Number(R_rasidWakildinar).toFixed(2)
                                }
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                              />
                            </td>
                          </tr>

                          <tr>
                            <th scope="row" style={{ fontSize: "25px" }}>
                              قەرزی نوێ
                            </th>
                            <td style={{ fontSize: "25px" }}>
                              <NumberFormat
                                value={
                                  IT_joripara == "دۆلار"
                                    ? Number.isInteger(
                                      Number(R_rasidWakildolarNew)
                                    )
                                      ? Number(R_rasidWakildolarNew)
                                      : Number(R_rasidWakildolarNew).toFixed(2)
                                    : Number.isInteger(
                                      Number(R_rasidWakildinarNew)
                                    )
                                      ? Number(R_rasidWakildinarNew)
                                      : Number(R_rasidWakildinarNew).toFixed(2)
                                }
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                              />
                            </td>
                          </tr>
                        </table>
                      </>
                    ) : null} */}
                  </div>
                  <div className="col-4">
                    <table className="responstable">
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          کۆی گشتی{IT_joripara === "دینار" ? "IQD" : "$"}
                        </th>
                        <td
                          className="text-danger1"
                          style={{
                            fontSize: "25px",
                            backgroundColor: "#80bfea"
                          }}
                        >
                          <NumberFormat
                            value={IT_total}
                            thousandSeparator={true}
                            displayType="text"
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          کۆی گشتی  {IT_joripara === "دینار" ? "$" : "IQD"}
                        </th>
                        <td
                          className="text-danger1"
                          style={{
                            fontSize: "25px",
                            backgroundColor: "#80bfea"
                          }}
                        >
                          <NumberFormat
                            value={IT_joripara === "دینار" ? dinartodolar(IT_total) : dolartodinar(IT_total)}
                            thousandSeparator={true}
                            displayType="text"
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          کەمکردنەوە
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          <NumberFormat
                            value={IT_discount}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          پارەی دراو
                        </th>
                        <td style={{ fontSize: "25px" }}>
                          <NumberFormat
                            value={IT_paied}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr>
                      {/* <tr>
                        <th scope="row" style={{ fontSize: "25px" }}>
                          پارەی ماوە
                        </th>
                        <td
                          className="text-danger1"
                          style={{
                            fontSize: "25px",
                            backgroundColor: "#80bfea"
                          }}
                        >
                          <NumberFormat
                            value={IT_paied}
                            displayType={"text"}
                            thousandSeparator={true}
                            dir="ltr"
                            prefix={IT_joripara == "دۆلار" ? "$" : "IQD"}
                          />
                        </td>
                      </tr> */}
                    </table>
                  </div>
                </div>
              </html>

            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfRent;
